<template>
    <div>
        <b-modal
            ref="graficaModal"
            size="xl"
            hide-footer
            no-close-on-backdrop
            title="Gráfica de Línea"
        >
            <chartLine :chart-data="chartData" :options="chartOptions" />
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios';
import chartLine from '../Charts/ChartLine.vue';

export default {
    components: {
        chartLine
    },
    data() {
        return {
            chartData: null,
            chartOptions: {
                responsive: true,
                plugins: {
                    legend: { display: true }
                },
                scales: {
                    x: {
                        title: { display: true, text: 'Hora' }
                    },
                    y: {
                        title: { display: true, text: 'Energía promedio (kWh)' }
                    }
                }
            }
        };
    },
    methods: {
        async show(item) {
            // Trae los datos de la API
            const res = await axios.get(`api/lecturas/${item.cbi}`, {
                headers: { Authorization: `Bearer ${this.$store.state.user.token}` }
            });
            const lecturas = res.data.lecturas;

            // Hora actual
            const ahora = new Date();
            let energiaPorHora = [];
            let labels = [];

            for (let i = 0; i < 12; i++) {
                const horaFin = new Date(ahora.getTime() - i * 60 * 60 * 1000);
                const horaInicio = new Date(horaFin.getTime() - 60 * 60 * 1000);

                // Filtra lecturas en ese rango
                const lecturasHora = lecturas.filter(l => {
                    const t = new Date(l.timestamp);
                    return t >= horaInicio && t < horaFin;
                });

                // Calcula el promedio de energía consumida en esa hora
                let sumaEnergia = 0;
                lecturasHora.forEach(l => {
                    let potencia = 0;
                    if (l.tiporede_id === 1) {
                        potencia = l.potencia_interior;
                    } else if (l.tiporede_id === 2) {
                        potencia = l.potencia_exterior + l.potencia_interior;
                    } else {
                        potencia = (3 * l.potencia_exterior * l.fp_exterior) + l.potencia_interior;
                    }
                    const tiempoOperacionEncendido = l.tiemposdeoperacione?.tiempo_encendido || 0;
                    const energia = (l.estado === 'ON') ? potencia * (tiempoOperacionEncendido / 3600) : 0;
                    sumaEnergia += energia;
                });

                const promedio = lecturasHora.length > 0 ? sumaEnergia / lecturasHora.length : 0;
                energiaPorHora.unshift(Number(promedio.toFixed(2))); // De más antiguo a más reciente

                // Etiqueta de la hora (ejemplo: "10:00")
                labels.unshift(horaInicio.getHours().toString().padStart(2, '0') + ':00');
            }

            // Configura los datos para el gráfico
            this.chartData = {
                labels: labels,
                datasets: [
                    {
                        label: 'Energía promedio por hora',
                        backgroundColor: 'rgba(54,162,235,0.2)',
                        borderColor: 'rgba(54,162,235,1)',
                        data: energiaPorHora,
                        fill: false
                    }
                ]
            };

            this.$refs['graficaModal'].show();
        },
        hide() {
            this.$refs['graficaModal'].hide();
        },
    },
}
</script>